import { PartsType, RealtimeData } from "../types/types";
import { addToCartShopify } from "./shopifyNavigation";

const isPieseMotor = (permanentDomain: string) => {
  return permanentDomain === "piesemotor.ro";
};

export const addToCard = async (
  permanentDomain: string,
  brand: string,
  part: PartsType | undefined,
  realtimeData: RealtimeData | undefined,
  variantIdLong: string | undefined,
  quantity: string
) => {
  console.log("addToCard", permanentDomain, brand, part, realtimeData, variantIdLong, quantity);
  if (isPieseMotor(permanentDomain)) {
    console.log("Call addToCardPieseMotor");
    try {
      addToCardPieseMotor(brand, part, realtimeData, quantity);
    } catch (e) {
      console.log("Error addToCardPieseMotor", e);
    }
  } else {
    console.log("Call addToCartShopify");
    try {
      addToCartShopify(variantIdLong, quantity, part, realtimeData);
    } catch (e) {
      console.log("Error addToCartShopify", e);
    }
  }
};

const addToCardPieseMotor = (brand: string, part: PartsType | undefined, realtimeData: RealtimeData | undefined, quantity: string) => {
  let price = realtimeData?.contextualPricing?.price.amount;
  if (!price) {
    price = part!.price || 0;
  }

  const data = {
    type: "inStock",
    attributes: {
      brand,
      reference: realtimeData ? realtimeData.sku : part!.id,
      part: {
        name: realtimeData ? realtimeData.title : part!.name,
        price,
      },
      currency: "lei",
      quantity: quantity,
    },
  };

  var manufacturer_id = (function (brand) {
    switch (brand.toUpperCase()) {
      case "KTM":
        return 110;
      case "HUSQVARNA":
        return 174;
      case "GASGAS":
        return 333;
    }
  })(data.attributes.brand);

  // @ts-ignore this is part of the piesemotor global object
  const prestashopGlobal = prestashop;

  $.ajax({
    type: "POST",
    url: prestashopGlobal.urls.base_url + "module/piesemotor_custom/cart?ajax=true",
    dataType: "json",
    data: {
      prod_reference: data.attributes.reference,
      quantity: data.attributes.quantity,
      prod_name: data.attributes.part.name,
      prod_price: data.attributes.part.price,
      manufacturer_id: manufacturer_id,
      manufacturer_name: data.attributes.brand,
    },
    success: function (data: any) {
      if (data.hasError) {
        alert("A aparut o eroare. Va rugam sa incercati din nou!");
        return;
      }
      prestashopGlobal.emit("updateCart", {
        resp: data,
        reason: "add-to-cart",
      });

      showPiesemotorAddToCart();
    },
    error: function () {
      alert("A aparut o eroare. Va rugam sa incercati din nou!");
    },
  });
};

export const openDetailPageOfProduct = (partRealdata: RealtimeData) => {
  if (partRealdata.aftermarketProductDetailUrl) {
    openAbsoluteUrl(partRealdata.aftermarketProductDetailUrl);
  } else if (partRealdata.variantId) {
    openShopifyDetailPage(partRealdata);
  }
};

const openAbsoluteUrl = (url: string) => {
  if (window?.top?.location) {
    window.top.location.href = url;
  }
};

const openShopifyDetailPage = (partRealdata: RealtimeData) => {
  if (!window) {
    return;
  }

  const handle = partRealdata.handle.replaceAll(" ", "-");
  const productPath = `products/${handle}?variant=${partRealdata.variantId}`;

  const newPage = `${window.location.protocol}//${window.location.hostname}/${productPath}`;
  window.open(newPage, "_blank");
};

const showPiesemotorAddToCart = () => {
  // Show success popup
  const successPopup = document.createElement("div");
  successPopup.className = "add-to-cart-success-popup";
  successPopup.innerHTML = `
    <div class="success-popup-content">
      <div class="success-icon">✓</div>
      <div class="success-message">Produsul a fost adăugat în coș cu succes!</div>
      <button class="close-popup-btn">×</button>
    </div>
  `;

  // Add styles
  const style = document.createElement("style");
  style.textContent = `
    .add-to-cart-success-popup {
      position: fixed;
      top: 20px;
      right: 20px;
      background-color: #fff;
      border: 1px solid #ddd;
      border-left: 4px solid #4CAF50;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
      padding: 15px;
      z-index: 9999;
      border-radius: 4px;
      animation: slideIn 0.3s ease-out;
    }
    .success-popup-content {
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .success-icon {
      color: #4CAF50;
      font-size: 20px;
      font-weight: bold;
    }
    .success-message {
      font-size: 14px;
    }
    .close-popup-btn {
      margin-left: 10px;
      background: none;
      border: none;
      font-size: 18px;
      cursor: pointer;
      color: #999;
    }
    @keyframes slideIn {
      from { transform: translateX(100%); opacity: 0; }
      to { transform: translateX(0); opacity: 1; }
    }
  `;

  document.body.appendChild(style);
  document.body.appendChild(successPopup);

  // Auto-close after 3 seconds
  setTimeout(() => {
    if (successPopup.parentNode) {
      successPopup.remove();
    }
  }, 5000);

  // Close on button click
  const closeBtn = successPopup.querySelector(".close-popup-btn");
  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      successPopup.remove();
    });
  }
};
